import request from '@/utils/request'

// 获取系统配置
export const getSystemConfig = () => {
  return request({
    url: '/system/config',
    method: 'get'
  })
}

// 更新系统配置
export const updateSystemConfig = (data) => {
  return request({
    url: '/system/config',
    method: 'put',
    data
  })
}

/** 上传微信支付 API 证书（apiclient_cert.p12），仅管理员 */
export const uploadWechatCert = (data) => {
  return request({
    url: '/system/wechat-cert/upload',
    method: 'post',
    data
  })
}